module.exports = __webpack_public_path__ + "static/media/bao2.4330210d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/bao2.png
// module id = 392
// module chunks = 0